module.exports = __webpack_public_path__ + "media/images/icons/outlined/line-chart-6b08bbb5af253e6fef531d587661cc86.svg";